export default __webpack_public_path__ + "static/media/watchdog-5.6be650a2.png";